export const serverStatus = "Live";

export const serverLink =
    serverStatus === "Dev"
        ? "http://localhost:5006/"
          : "https://aum.gargatechapi.com.ng/" // AL-ANSAR

export const simpleFileUploadAPIKey = "305e0ddf925a3fc5dd34d314f8230349";


export const projectName = "Al-Ansar University";
export const projectPhone = "+234 803 629 5382";
export const projectEmail = "info@aum.edu.ng"
export const projectAddress = "Al-Ansar University, Maiduguri, Nigeria";
export const AdmissionBankName = "TAJ BANK";
export const AdmissionAcctNo = "0015058895";
export const AdmissionAcctName = "AL-ANSAR UNIVERSITY 26/27 COLLECTION ACCOUNT";

